import { render, staticRenderFns } from "./QuestionarioCentroMultiprofissional.vue?vue&type=template&id=3935e593&scoped=true"
import script from "./QuestionarioCentroMultiprofissional.vue?vue&type=script&lang=js"
export * from "./QuestionarioCentroMultiprofissional.vue?vue&type=script&lang=js"
import style0 from "./QuestionarioCentroMultiprofissional.vue?vue&type=style&index=0&id=3935e593&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3935e593",
  null
  
)

export default component.exports